var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrocmsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.998 0H24.9997C11.1927 0 0 11.1929 0 25V175C0 188.807 11.1927 200 24.9997 200H174.998C188.804 200 199.997 188.807 199.997 175V25C199.997 11.1929 188.804 0 174.998 0Z",
    fill: "#2B2C30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.948 89.7373C155.51 87.2998 151.548 87.2998 149.111 89.7373L96.9612 141.887L89.8863 134.812L75.749 148.95L82.8239 156.025L92.5488 165.75C94.9863 168.187 98.9487 168.187 101.386 165.75L153.535 113.6L160.61 120.675L174.748 106.537L157.948 89.7373Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4621 120.675L61.5996 106.538L54.5246 99.4625L96.9496 57.0375L104.025 64.1125L118.162 49.975L101.375 33.1875C98.9371 30.75 94.9746 30.75 92.5371 33.1875L30.6746 95.0375C28.2371 97.475 28.2371 101.438 30.6746 103.875L47.4621 120.662V120.675Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.661 61.4502C127.223 59.0127 123.261 59.0127 120.823 61.4502L54.5366 127.738L68.6739 141.875L125.248 85.3002L132.323 92.3752L146.46 78.2377L129.661 61.4502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrocmsSmall);
export default __webpack_public_path__ + "static/media/microcms-small.87f53499bc2d8752f88e4b30da00d7fb.svg";
export { ForwardRef as ReactComponent };